import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
export default function ProductBrand(t0) {
  const $ = _c(4);
  const {
    product
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>By :</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `/brands/${product?.brand?.brand_slug}`;
  const t3 = product?.brand?.brand_name;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = <div className="flex my-1 gap-1">{t1}<Link className="font-bold" href={t2}>{t3}</Link></div>;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
}